import React from 'react';
import { Link } from 'react-router-dom';
import ShieldLogo from './ShieldLogo';

const Footer = () => {
  return (
    <footer className="border-t border-[#e0ddd8] mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-7 sm:py-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <Link
            to="/"
            className="inline-flex items-center gap-2 hover:opacity-70 transition-opacity"
          >
            <ShieldLogo size={20} />
            <span
              className="text-xl font-semibold"
              style={{ fontFamily: 'Instrument Serif, serif' }}
            >
              Verilock
            </span>
          </Link>
          
          <div className="flex flex-wrap justify-center items-center gap-x-4 sm:gap-x-6 gap-y-2 text-sm">
            <Link to="/about" className="text-[#1a1a1a]/70 hover:text-[#1a1a1a] transition-colors">
              About
            </Link>
            <span className="text-[#1a1a1a]/30 hidden sm:inline">·</span>
            <Link to="/contact" className="text-[#1a1a1a]/70 hover:text-[#1a1a1a] transition-colors">
              Contact
            </Link>
            <span className="text-[#1a1a1a]/30 hidden sm:inline">·</span>
            <Link to="/privacy" className="text-[#1a1a1a]/70 hover:text-[#1a1a1a] transition-colors">
              Privacy
            </Link>
            <span className="text-[#1a1a1a]/30 hidden sm:inline">·</span>
            <Link to="/terms" className="text-[#1a1a1a]/70 hover:text-[#1a1a1a] transition-colors">
              Terms
            </Link>
          </div>
        </div>
        
        <div className="mt-5 sm:mt-6 text-center text-xs text-[#1a1a1a]/60 leading-relaxed">
          © 2026 Verilock. Compliance guidance for early-stage founders. Not legal advice.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
